import { configureStore } from "@reduxjs/toolkit";
import bookingsListReducer from "./bookings/bookings.slice";
import bookingSettingsReducer from "./bookingSettings/booking-settings.slice";
import carriersListReducer from "./carriers/carriers.slice";
import carrierDetailReducer from "./carrierDetail/carrier-detail.slice";
import customerDetailReducer from "./customerDetail/customer-detail.slice";
import customersListReducer from "./customers/customers.slice";
import settingsUsersReducer from "./settingsUsers/settings-users.slice";

export const store = configureStore({
  reducer: {
    settingsUsers: settingsUsersReducer,
    bookingSettings: bookingSettingsReducer,
    customerDetail: customerDetailReducer,
    customersList: customersListReducer,
    bookingsList: bookingsListReducer,
    carriersList: carriersListReducer,
    carrierDetail: carrierDetailReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
